// Bahasa Melayu (Malaysia). Same shape as id.js; any key missing here falls
// back to Indonesian.
const ms = {
    common: {
        back: 'Kembali',
        close: 'Tutup',
        menu: 'Menu',
        login: 'Log masuk',
        redirecting: 'Mengubah hala...',
        sessionExpired: 'Sesi anda telah tamat. Sila log masuk semula.',
        genericError: 'Berlaku ralat. Sila cuba lagi.',
        days: '{n} Hari',
        packages: '{n} Pakej',
        popular: 'Popular',
        promo: 'Promo',
        topUp: 'Tambah Nilai',
        sort: 'Susun',
        seeAll: 'Lihat Semua',
    },
    help: {
        title: 'Ada Masalah?',
        desc: 'Jangan risau, kami sedia membantu sehingga selesai.',
        cta: 'Sembang Sekarang',
    },
    nav: {
        shop: 'Kedai',
        esim: 'eSIM',
        profile: 'Profil',
    },
    language: {
        label: 'Bahasa',
        choose: 'Pilih Bahasa',
    },
    home: {
        title: 'Kekal Terhubung **Tanpa Had** di Luar Negara!',
        cta: 'Akses internet pantas di mana-mana sahaja dengan Arta Mobile!',
        networkText: 'Dapatkan akses ke rangkaian terbaik di seluruh dunia',
        networkAria: 'Rakan rangkaian kami',
        promoTitle: 'Sedang Promo!',
        prev: 'Sebelumnya',
        next: 'Seterusnya',
        otherPackages: 'Pilihan Pakej Lain',
        categoryAria: 'Kategori negara',
        tabs: {
            popular: 'Negara Popular',
            umrah: 'Umrah / Haji',
            multi: 'Pelbagai Negara',
        },
        openRegion: 'Buka {name}',
        startingFrom: 'Bermula dari',
        loadError: 'Gagal memuatkan destinasi.',
        retry: 'Cuba Lagi',
        empty: 'Tiada destinasi dalam kategori ini.',
        showLess: 'Kurangkan',
        howTitle: 'Tak Leceh! Cara Guna eSIM',
        steps: [
            { title: 'Beli Pakej', desc: 'Pilih mengikut destinasi' },
            { title: 'Imbas QR', desc: 'Pasang & aktifkan dalam beberapa saat' },
            { title: 'Sedia Digunakan', desc: 'Nikmati internet di luar negara' },
        ],
        faqTitle: 'Soalan Lazim',
        faqs: [
            {
                q: 'Apakah itu eSIM?',
                a: 'eSIM (embedded SIM) ialah SIM digital yang terbina terus dalam peranti anda. Anda boleh mengaktifkan pelan data tanpa kad SIM fizikal — hanya imbas kod QR dan terus terhubung.',
            },
            {
                q: 'Adakah telefon saya menyokong eSIM?',
                a: 'Kebanyakan iPhone (XS dan ke atas), Samsung Galaxy S20 dan ke atas, Google Pixel 3 dan ke atas, serta banyak peranti Android utama lain menyokong eSIM. Pastikan telefon anda tidak dikunci oleh pembawa (carrier lock).',
            },
            {
                q: 'Bilakah eSIM mula aktif?',
                a: 'eSIM aktif secara automatik kali pertama anda menyambung ke rangkaian di negara destinasi. Jadi tidak perlu risau data digunakan sebelum anda benar-benar berlepas.',
            },
            {
                q: 'Bolehkah saya masih menerima panggilan & SMS ke nombor asal saya?',
                a: 'Ya, boleh. eSIM Arta Mobile dipasang sebagai SIM kedua. Nombor pada SIM utama anda kekal aktif untuk menerima panggilan dan SMS, manakala eSIM digunakan untuk data internet.',
            },
            {
                q: 'Berapa lama tempoh sah pakej dan apa berlaku jika data habis?',
                a: 'Tempoh sah berbeza mengikut pakej yang anda pilih (dari 3 hingga 30 hari). Jika data habis sebelum tempoh sah tamat, sambungan akan berhenti secara automatik. Anda boleh membeli pakej baharu pada bila-bila masa.',
            },
            {
                q: 'Bagaimana jika kod QR tidak dapat diimbas?',
                a: 'Pastikan anda memasang eSIM semasa ada sambungan internet (Wi-Fi). Jika kod QR masih tidak dapat dibaca, anda boleh memasukkan kod pengaktifan secara manual. Hubungi pasukan kami melalui WhatsApp jika masih ada masalah — kami sedia membantu 24/7.',
            },
        ],
        footerDesc: 'Arta Mobile ialah eSIM daripada PT. Arta Komunikasi Global yang hadir untuk memudahkan perjalanan anda ke luar negara.',
        followUs: 'Ikuti Kami',
    },
    search: {
        placeholder: 'Cari negara destinasi',
        clear: 'Padam carian',
    },
    region: {
        loading: 'Memuatkan…',
        loadError: 'Gagal memuatkan.',
        topbarTitle: 'eSIM {name}',
        desc: 'Nikmati sambungan 5G yang lancar di {name} dengan rangkaian tempatan kami.',
        pillSpeed: 'Kelajuan 4G/5G',
        pillHotspot: 'Hotspot Tersedia',
        bannerTitle: 'Sedia untuk terhubung?',
        bannerSub: 'Semak Telefon Menyokong eSIM',
        bannerCta: 'Semak Di Sini',
        packagesTitle: 'Pakej Tersedia',
        packagesSub: 'Pilih pakej data terbaik untuk perjalanan anda.',
        listView: 'Paparan senarai',
        gridView: 'Paparan grid',
        sortOptions: {
            default: 'Susunan Lalai',
            'price-asc': 'Harga Terendah',
            'price-desc': 'Harga Tertinggi',
            'data-desc': 'Data Terbanyak',
            'data-asc': 'Data Terkecil',
        },
        simCardTab: 'Kad SIM',
        simCardTitle: 'Kad SIM Arab Saudi',
        simCardSub: 'Telefon anda tidak menyokong eSIM? Gunakan SIM Fizikal Arta Mobile',
        simCardCta: 'Pesan di Shopee',
        advTitle: 'Kelebihan Perkhidmatan Kami',
        advSub: 'Nikmati kemudahan dan keselesaan menggunakan eSIM kami di {name}.',
        advantages: [
            { title: 'Tempoh Sah', desc: 'Bermula secara automatik apabila eSIM menyambung ke rangkaian di negara destinasi' },
            { title: 'Tanpa Pendaftaran', desc: 'Tidak perlu kad pengenalan atau pasport' },
            { title: 'Boleh Tambah Nilai', desc: 'Tambah data dengan mudah semasa dalam perjalanan' },
        ],
        otherTitle: 'Pilihan Pakej Lain',
        startingFrom: 'Dari {price}',
        coverageTitle: 'Liputan Negara',
        coverageCount: '{n} negara',
        showLess: 'Tunjuk lebih sedikit',
        showAll: 'Tunjuk semua',
    },
    devices: {
        dialogAria: 'Senarai Peranti eSIM',
        title: 'Sokongan Peranti',
        version: 'V. 2.4.0 • DIKEMAS KINI SEPT 2025',
        searchPlaceholder: 'Cari model peranti anda...',
        searchAria: 'Cari peranti',
        clearSearch: 'Padam carian',
        all: 'Semua',
        models: '{n} MODEL',
        others: 'Jenama Lain',
        emptyTitle: 'Tidak dijumpai',
        emptyDesc: 'Peranti "{query}" tiada dalam senarai kami.',
        reset: 'Set semula carian',
        noteTitle: 'Peranti Tiada Dalam Senarai?',
        noteDesc: 'Peranti selepas 2021 biasanya menyokong eSIM. Jika tidak kelihatan, hubungi sokongan atau semak tetapan.',
    },
    payment: {
        title: 'Pembayaran',
        topupTitle: 'Tambah Nilai eSIM {region}',
        emailTopup: 'Tambah nilai eSIM ICCID {iccid}',
        emailNew: 'eSIM anda akan dihantar ke {email}',
        methodsTitle: 'Kaedah Pembayaran',
        methods: {
            qris: 'Gopay, Shopeepay, OVO, Dana, LinkAja',
            gopay: 'Bayar segera dengan aplikasi Gopay',
        },
        promoTitle: 'Promo & Baucar',
        promoPlaceholder: 'Masukkan kod promo',
        promoChecking: 'Menyemak...',
        promoCheck: 'Guna',
        promoApplied: 'Promo **{code}** berjaya digunakan.',
        promoEmpty: 'Sila masukkan kod promo terlebih dahulu.',
        promoNotFound: 'Kod promo tidak dijumpai.',
        promoInvalid: 'Kod promo tidak dijumpai.',
        consent: 'Dengan menekan butang bayar, anda bersetuju dengan Terma dan Syarat serta Dasar Privasi artamobile.id',
        total: 'Jumlah Bayaran',
        processing: 'Memproses...',
        payNow: 'Bayar Sekarang',
    },
    qris: {
        appbar: 'Menunggu Pembayaran',
        title: 'Lengkapkan Pembayaran',
        helper: 'Imbas kod QRIS ini menggunakan aplikasi bank anda. Pembayaran akan dikesan secara automatik.',
        expired: 'Kod QR Tamat Tempoh',
        expiresIn: 'Tamat dalam {time}',
        unknownExpiry: 'Masa tamat tempoh tidak diketahui',
        noQr: 'Kod QR tidak tersedia.',
        checkStatusAria: 'Semak Status Pembayaran',
        checking: 'Menyemak...',
        checkStatus: 'Semak Status',
        saveToPhotos: 'Simpan ke Foto',
        saveQr: 'Simpan Kod QR',
        shareTitle: 'Pembayaran QRIS',
        shareText: 'Simpan imej ke Foto.',
        statusCreated: 'Pembayaran belum diterima. Jika sudah membayar, tunggu 1–2 minit dan semak semula.',
        statusExpired: 'Kod QR telah tamat tempoh. Sila buat pembayaran baharu.',
        statusOther: 'Status pembayaran: {status}. Sila tunggu sebentar.',
        statusError: 'Gagal menyemak status. Cuba lagi.',
        total: 'Jumlah Bayaran',
        copyAmount: 'Salin jumlah',
        howTitle: 'Cara Membayar',
        steps: [
            { title: 'Buka Aplikasi', desc: 'Buka aplikasi perbankan mudah alih atau e-dompet pilihan anda (Gopay, OVO, Dana, dll).' },
            { title: 'Imbas Kod QR', desc: "Pilih menu 'Imbas' atau 'Bayar' dan halakan kamera ke kod QR pada skrin ini." },
            { title: 'Sahkan', desc: 'Pastikan jumlah betul, masukkan PIN, dan transaksi selesai secara automatik.' },
        ],
    },
    paymentStatus: {
        steps: {
            esim: [
                { title: 'Pengesahan Pembayaran', sub: 'Disahkan secara automatik' },
                { title: 'Mencipta eSIM Anda', sub: 'Menyambung ke penyedia global...' },
                { title: 'Hantar ke E-mel', sub: 'Arahan akan dihantar ke peti masuk anda' },
            ],
            topup: [
                { title: 'Pengesahan Pembayaran', sub: 'Disahkan secara automatik' },
                { title: 'Menambah Pakej Data', sub: 'Memproses pakej data anda...' },
                { title: 'Pakej Data Aktif', sub: 'Data akan tersedia sebentar lagi' },
            ],
        },
        headings: {
            processing: {
                esim: { pill: 'PROSES MASA NYATA', title: 'eSIM Sedang Dikeluarkan', sub: 'Kami sedang menyediakan sambungan anda. Sila tunggu sebentar.' },
                topup: { pill: 'PROSES MASA NYATA', title: 'Tambah Nilai Sedang Diproses', sub: 'Kami sedang menambah pakej data anda. Sila tunggu sebentar.' },
            },
            success: {
                esim: { pill: 'SELESAI', title: 'eSIM Berjaya Dikeluarkan', sub: 'eSIM anda telah dikeluarkan dan dihantar ke e-mel anda.' },
                topup: { pill: 'SELESAI', title: 'Tambah Nilai Berjaya', sub: 'Pakej data anda telah berjaya ditambah.' },
            },
            failed: {
                esim: { pill: 'GAGAL', title: 'Pembayaran Gagal', sub: 'Maaf, pembayaran tidak dapat diselesaikan. Sila cuba lagi.' },
                topup: { pill: 'GAGAL', title: 'Pembayaran Gagal', sub: 'Maaf, pembayaran tidak dapat diselesaikan. Sila cuba lagi.' },
            },
        },
        orderStatus: 'Status Pesanan',
        orderNotFound: 'Nombor pesanan tidak dijumpai.',
        appbarTopup: 'Tambah Nilai',
        appbarEsim: 'Pengeluaran eSIM',
        backHome: 'Kembali ke Laman Utama',
        viewEsims: 'Lihat eSIM Saya',
        retry: 'Cuba Lagi',
    },
    esims: {
        title: 'SIM Saya',
        loadingAria: 'Memuatkan eSIM anda',
        active: 'Aktif',
        archived: 'Arkib',
        count: '{n} eSIM',
        newest: 'Terbaharu',
        oldest: 'Terlama',
        loadError: 'Berlaku ralat semasa memuatkan eSIM.',
        buyNew: 'Beli eSIM baharu',
        loginTitle: 'Log Masuk untuk Melihat eSIM Anda',
        loginDesc: 'Simpan dan urus semua pelan data perjalanan anda di satu tempat yang selamat.',
        emptyActiveTitle: 'Belum Ada eSIM Aktif',
        emptyActiveDesc: 'Mulakan pengembaraan anda dengan memilih pakej data terbaik untuk perjalanan seterusnya.',
        emptyArchiveTitle: 'Arkib Kosong',
        emptyArchiveDesc: 'eSIM yang tidak aktif atau tidak digunakan lagi akan muncul di sini supaya senarai aktif anda kekal kemas.',
        topupTitle: 'Tambah Data',
        topupSubtitle: 'Pilih data yang ingin ditambah ke eSIM anda',
    },
    esimCard: {
        status: {
            created: 'Sedia Diaktifkan',
            inUse: 'Aktif',
            usedUp: 'Data Habis',
            expired: 'Tamat Tempoh',
            cancelled: 'Dibatalkan',
        },
        iccid: 'ICCID: {iccid}',
        purchased: 'Tarikh Beli: {date}',
        checkQuota: 'Semak Data',
    },
    topupModal: {
        title: 'Tambah Data',
        subtitle: 'Pilih pakej data yang ingin anda tambah.',
        empty: 'Belum ada pakej tambah nilai yang tersedia.',
        validity: 'Sah selama {n} hari',
    },
    esimDetail: {
        loadError: 'Gagal memuatkan eSIM. Sila cuba lagi.',
        planStatus: {
            active: 'Aktif',
            terminated: 'Tamat',
            notActive: 'Sedia Dipasang',
        },
        sorts: {
            'price-asc': 'Harga Terendah',
            'price-desc': 'Harga Tertinggi',
            'data-asc': 'Data Terkecil',
            'data-desc': 'Data Terbanyak',
        },
        validUntil: 'Sah sehingga',
        useBefore: 'Guna Sebelum',
        shareTitle: '{label} — Arta Mobile',
        shareText: 'Butiran {label} di Arta Mobile',
        linkCopied: 'Pautan disalin ke papan klip',
        linkCopyFailed: 'Gagal menyalin pautan',
        rename: 'Tukar Nama',
        share: 'Kongsi',
        sendEmail: 'Hantar e-mel',
        archive: 'Arkibkan',
        archiveWait: 'Tunggu bayaran balik selesai',
        refundStatus: 'Status bayaran balik',
        requestRefund: 'Mohon bayaran balik',
        refundChecking: 'Menyemak…',
        refundBanner: {
            review: { title: 'Bayaran balik sedang disemak CS', sub: 'Maks. {sla}. eSIM masih boleh digunakan semasa disemak.' },
            processing: { title: 'Bayaran balik sedang diproses', sub: 'Wang dikembalikan ke kaedah pembayaran asal.' },
            done: { title: 'Bayaran balik selesai', sub: 'Wang telah dikembalikan ke kaedah pembayaran asal.' },
            rejected: { title: 'Bayaran balik ditolak', sub: 'Lihat sebabnya di status bayaran balik.' },
        },
        installTitle: 'Panduan Pemasangan eSIM',
        installSub: 'Aktifkan eSIM pada peranti anda',
        tabQuota: 'Data',
        tabHistory: 'Sejarah',
        gbLeft: 'GB BAKI',
        usedData: 'DATA DIGUNAKAN',
        totalData: 'JUMLAH DATA',
        noHistory: 'Belum ada sejarah pakej.',
        validity: 'Tempoh Sah',
        quota: 'Data',
        ends: 'Tamat',
        warningTitle: 'Perhatian!',
        warningBody: 'Jangan padam eSIM. eSIM yang dipadam tidak boleh dipasang semula.',
        topupTitle: 'Tambah Nilai Pakej Anda',
    },
    esimLegacy: {
        loading: 'Memuatkan...',
        warningBody: 'Jangan padam eSIM. eSIM yang dipadam tidak boleh dipasang semula.',
        install: 'Arahan Pemasangan eSIM',
        usage: 'PENGGUNAAN',
        remaining: 'BAKI DATA',
        expires: 'Tamat',
        myPackages: 'PAKEJ SAYA',
        expiry: 'Tarikh Tamat',
        validity: 'Tempoh Sah',
        days: '{n} Hari',
        data: 'Data',
        status: {
            ACTIVE: 'Aktif',
            TERMINATED: 'Tamat Tempoh',
            NOT_ACTIVE: 'Tidak Aktif',
        },
        renameAria: 'Tukar nama eSIM',
        menuAria: 'Tunjuk menu',
        rename: 'Tukar Nama',
        shareEmail: 'Kongsi melalui E-mel',
        archive: 'Arkibkan eSIM',
        country: 'Negara',
        sharedWith: 'Dikongsi',
        topupHeader: 'TAMBAH NILAI',
        topupAria: 'Pilihan tambah nilai',
        topupCta: 'Tambah nilai',
    },
    renameModal: {
        title: 'Tukar nama eSIM',
        info: 'Ini hanya menukar nama eSIM dalam aplikasi — bukan nama dalam tetapan peranti anda.',
        label: 'Nama eSIM',
        remaining: '{n} aksara lagi.',
        saving: 'Menyimpan…',
        submit: 'Tukar nama eSIM',
        success: 'Nama eSIM berjaya dikemas kini!',
        failed: 'Gagal mengemas kini nama eSIM. Cuba lagi.',
    },
    shareModal: {
        title: 'Kongsi melalui E-mel',
        info: 'Hantar butiran eSIM (termasuk kod pengaktifan) ke alamat e-mel penerima.',
        label: 'E-mel penerima',
        placeholder: 'nama@contoh.com',
        invalid: 'Alamat e-mel tidak sah.',
        sending: 'Menghantar…',
        send: 'Hantar',
        success: 'Butiran eSIM berjaya dihantar ke e-mel penerima.',
        failed: 'Gagal menghantar e-mel. Cuba lagi.',
    },
    archiveModal: {
        title: 'Arkibkan eSIM?',
        body: 'eSIM yang diarkibkan tidak akan muncul dalam senarai utama, tetapi data sejarah masih disimpan dalam sistem.',
        confirmQuestion: 'Adakah anda pasti mahu mengarkibkan eSIM ini?',
        cancel: 'Batal',
        archiving: 'Mengarkibkan…',
        confirm: 'Arkibkan eSIM',
        success: 'eSIM berjaya diarkibkan.',
        failed: 'Gagal mengarkibkan eSIM. Cuba lagi.',
    },
    review: {
        title: 'Ulasan Anda',
        body: 'Bantu kami mengekalkan kualiti rangkaian di setiap destinasi.',
        questionRegion: 'Bagaimana sambungan di {region}?',
        question: 'Bagaimana sambungan?',
        submitError: 'Gagal menghantar ulasan. Cuba lagi.',
        doneAria: 'Ulasan anda {n} daripada 5',
        thanks: 'Terima kasih atas ulasan anda.',
        star: '{n} bintang',
        placeholder: 'Tulis komen anda (pilihan)',
        sending: 'Menghantar…',
        submit: 'Hantar ulasan',
    },
    installCard: {
        stages: {
            NOT_STARTED: {
                title: 'eSIM belum dipasang',
                body: 'Pasang eSIM sebelum berlepas. Prosesnya hanya mengambil beberapa minit dan sambungan internet.',
            },
            STALLED: {
                title: 'Pemasangan belum selesai',
                body: 'Pemasangan eSIM anda terhenti separuh jalan. Sila cuba pasang semula.',
            },
            INSTALLED: {
                title: 'eSIM telah dipasang',
                body: 'Jangan lupa aktifkan perayauan data dalam tetapan telefon anda.',
            },
            DELETED: {
                title: 'Profil eSIM dipadam daripada peranti',
                body: 'Profil eSIM ini sudah tiada dalam telefon anda.',
            },
        },
        question: 'Bagaimana proses pemasangan eSIM ini?',
    },
    install: {
        appbar: 'Pilih Kaedah',
        tabsAria: 'Mod pemasangan',
        tabs: {
            instant: 'Segera',
            qr: 'Imbas QR',
            manual: 'Manual',
        },
        wifiWarn: 'Pastikan telefon disambungkan ke internet yang stabil semasa memasang eSIM.',
        notIos: 'Ciri pemasangan segera hanya tersedia pada **iPhone**. Gunakan kaedah **Imbas QR** atau **Manual**.',
        oldIos: 'Ciri pemasangan segera hanya tersedia pada **iOS 17.4** dan ke atas. Gunakan kaedah **Imbas QR** atau **Manual**.',
        detected: 'Peranti Dikesan',
        unknownOs: 'OS tidak diketahui',
        step1: 'Langkah 1/2 — Pasang eSIM',
        step2: 'Langkah 2/2 — Hidupkan Perayauan',
        instantStep: 'Pasang eSIM menggunakan butang di bawah',
        roaming1: 'Aktifkan **Perayauan Data**.',
        roaming2: 'Tetapkan eSIM sebagai talian **Data Mudah Alih** apabila tiba di negara destinasi.',
        installBtn: 'Pasang eSIM pada iPhone ini',
        qrLead1: 'Imbas QR di bawah dengan telefon',
        qrLead2: 'yang akan menggunakan eSIM',
        qrAlt: 'Kod QR untuk pemasangan eSIM',
        qrIphone: '**iPhone**: Tetapan → Data Mudah Alih → Tambah eSIM → Guna Kod QR',
        qrAndroid: '**Android**: Tetapan → Sambungan/Rangkaian → Pengurus SIM → Tambah eSIM → Guna QR',
        smdp: 'Alamat SM-DP+',
        activationCode: 'Kod Pengaktifan',
        copy: 'Salin',
        copied: 'Disalin',
        manualIphone: '**iPhone**: Tetapan → Data Mudah Alih → Tambah eSIM → **Masukkan Butiran Secara Manual** (isi Alamat SM-DP+ dan Kod Pengaktifan di atas)',
        manualAndroid: '**Android**: Tetapan → Sambungan/Rangkaian → Pengurus SIM → Tambah eSIM → **Masukkan Kod**',
        copyFailed: 'Gagal menyalin – sila salin secara manual.',
        iphoneOnly: 'Ciri ini hanya tersedia pada iPhone.',
        confirm: 'Pasang eSIM pada iPhone ini sekarang?',
    },
    kuota: {
        loadingAria: 'Memuatkan',
        loginTitle: 'Log Masuk untuk Semak Data',
        loginDesc: 'Log masuk ke akaun Arta Mobile anda terlebih dahulu untuk menyemak baki data kad SIM.',
        linkingAria: 'Memautkan kad SIM',
        linking: 'Memautkan kad SIM ke akaun anda…',
        scanTitle: 'Imbas Kod Bar',
        scanDesc: 'Halakan kamera ke kod bar pada pembungkusan kad SIM anda.',
        cancel: 'Batal',
        introTitle: 'Semak Data Kad SIM',
        introDesc: 'Imbas kod bar pada pembungkusan kad SIM untuk memautkannya ke akaun anda dan melihat baki data.',
        scanBtn: 'Imbas Kod Bar',
        hideManual: 'Sembunyikan input manual',
        showManual: 'Masukkan nombor ICCID secara manual',
        iccidLabel: 'Nombor ICCID',
        checkQuota: 'Semak Data',
        errors: {
            unrecognized: 'Nombor ICCID tidak dikenali. Cuba imbas semula atau masukkan secara manual.',
            unverified: 'Akaun anda belum disahkan. Sila sahkan e-mel anda terlebih dahulu.',
            notFound: 'Kad SIM tidak dijumpai. Pastikan kod bar pada pembungkusan diimbas dengan betul.',
            linkFailed: 'Gagal memautkan kad SIM. Sila cuba lagi.',
            camera: 'Kamera tidak dapat diakses. Benarkan akses kamera dalam tetapan pelayar, atau masukkan nombor ICCID secara manual.',
        },
    },
    profile: {
        loginTitle: 'Log Masuk untuk Mengakses Profil',
        loginDesc: 'Urus akaun dan pilihan anda di satu tempat.',
        userFallback: 'Pengguna',
        avatarAlt: 'Profil',
        preferences: 'Pilihan',
        currency: 'Mata Wang',
        currencyValue: 'IDR - Rupiah',
        support: 'Sokongan',
        contact: 'Hubungi Kami',
        logout: 'Log keluar',
    },
    refund: {
        slaLabel: '3×24 jam',
        reasons: {
            TRIP_CANCELLED: 'Perjalanan dibatalkan',
            WRONG_PACKAGE: 'Tersilap pilih negara atau pakej',
            DEVICE_NOT_SUPPORTED: 'Telefon tidak menyokong eSIM',
            OTHER: 'Lain-lain',
        },
        ineligible: {
            ESIM_IN_USE: 'eSIM sudah aktif',
            WINDOW_EXPIRED: 'Melebihi 30 hari sejak pembelian',
            NOT_SELF_SERVICE: 'Hubungi CS untuk bayaran balik',
            PROVIDER_UNAVAILABLE: 'Tidak dapat disemak sekarang, cuba lagi nanti',
        },
        status: {
            review: 'Disemak CS',
            done: 'Selesai',
            rejected: 'Ditolak',
            processing: 'Diproses',
        },
        payment: {
            credit_card: 'kad kredit',
            bank_transfer: 'pindahan bank',
        },
        request: {
            title: 'Mohon bayaran balik',
            checking: 'Menyemak eSIM…',
            forbiddenTitle: 'Hanya pembeli boleh memohon bayaran balik',
            forbiddenBody: 'Log masuk dengan e-mel yang digunakan semasa membeli eSIM ini, atau hubungi CS.',
            errorTitle: 'Gagal menyemak eSIM',
            errorBody: 'Cuba lagi sebentar nanti.',
            retry: 'Cuba lagi',
            notEligibleTitle: 'Belum layak untuk bayaran balik',
            notEligibleDefault: 'eSIM ini tidak layak untuk bayaran balik.',
            contactCs: 'Hubungi CS jika ada masalah.',
            chatCs: 'Sembang dengan CS melalui WhatsApp',
            eligibleTitle: 'Layak untuk bayaran balik',
            eligibleBody: 'Pasukan CS menyemak dalam maks. {sla}. Wang dikembalikan secara automatik ke kaedah pembayaran asal, tanpa perlu mengisi butiran akaun bank.',
            reasonLegend: 'Sebab bayaran balik',
            note: 'Catatan',
            optional: '(pilihan)',
            notePlaceholder: 'Ceritakan ringkas masalah anda',
            validity: 'Tempoh sah {n} hari',
            footerNote: 'Jika diluluskan, eSIM akan dinyahaktifkan dan tidak boleh digunakan lagi.',
            sending: 'Menghantar…',
            networkError: 'Masalah sambungan. Cuba lagi.',
            submitError: 'Gagal menghantar permohonan. Cuba lagi atau hubungi CS.',
        },
        statusPage: {
            title: 'Status bayaran balik',
            loading: 'Memuatkan status bayaran balik…',
            forbidden: 'Status bayaran balik hanya boleh dilihat oleh pembeli eSIM ini.',
            loadError: 'Gagal memuatkan status bayaran balik.',
            retry: 'Cuba lagi',
            none: 'Belum ada permohonan bayaran balik untuk eSIM ini.',
            request: 'Mohon bayaran balik',
            toOriginal: 'ke kaedah pembayaran asal',
            askCs: 'Tanya CS melalui WhatsApp',
            steps: {
                received: 'Permohonan diterima',
                reviewed: 'Disemak oleh pasukan CS',
                reviewSub: 'Maks. {sla}. eSIM masih boleh digunakan semasa disemak.',
                deactivated: 'eSIM dinyahaktifkan',
                refunded: 'Wang dikembalikan',
                refundedSub: 'Masa diterima bergantung pada bank atau e-dompet',
                rejected: 'Ditolak',
            },
        },
    },
};

export default ms;
